import React, { Component } from 'react';
import { LastAddedItem, PopupMessage, ProductPrice, SvgImage } from '..';
import { VectorCartLogoNew, cartIcon, listIcon } from '../../../style/images';
import { connect } from 'react-redux';
import { productsDispatcher, cartDispatcher, importDispatcher, cartState, combineDispatchers, popupDispatcher, siteSettingsState, combineStates, productState, identityState, priceDispatcher, mobilePageViewDispatcher, showConfigureState, superCodeDispatcher,flagDispatcher,flagState} from '../../store';
import { localStore, translate } from '../../services';
import { PropTypes } from 'prop-types';
import { Link,withRouter} from 'react-router-dom';
import { convertToLineItem, getMissingBomItemCodes, getUserAssignments, PricingModule, getConfiguration, getAccessories } from '../../util';
import { PopupType } from '../FeasibilityResultPopup';
import { Badge, Box, Dialog, Icon } from '@mui/material';
import classNames from 'classnames';
import { RemoveProductsCart } from './RemoveProductsCart';

const urlIsIntegrated = window.location.href.includes('?');
const isIntegrated = () => window.parent !== window && urlIsIntegrated;
var click=false;



export class CartSummaryMenuComponent extends Component {

  constructor(props){
    super();
    this.state={
      show:false
    }
  }

  async loadProductsFromLocalStore() {
    let {products, user, siteSettings} = this.props;
    if( isIntegrated() ) return {};
    let productListFromStore = localStore.get( 'cart' );
    let productList=[];
    productListFromStore.forEach(d=>{
      if(d.importAccessories && d.importAccessories.length==0){
        productList.push(d)
      }
    })
    productListFromStore.forEach(d=>{
      if(d.importAccessories && d.importAccessories.length>0){

        productList.push({...d,superCodeLSO:d.superCodeLSO=="-"?'待开':d.superCodeLSO})
      }
    })
    if(productList && productList.length) {
      let result = await this.props.validate( productList );

      productList?.forEach(product=>{
        result.products?.forEach(res=>{
          if(res.code==product.product || res.name==product.product){
            res.description=product.description
          }
        })
      })
      // if the combinationId of a product is not equal to -1 then they are fp+mp products
      //const combinationProducts = result.products?.filter( product => product.combinationId !== -1 );

      let index = 0;
      // loop through the configurations and add additionalProducts property with corresponding combinationProduct as value 
      // combinationProducts.length > 0 && result.configurations?.forEach( configuration => {
      //   if( configuration.combinationId !== -1 ){
      //     const combinationProduct = combinationProducts[index]
      //     configuration.additionalProducts = [combinationProduct];
      //     index += 1;
      //   }
      // })

      const codes = getMissingBomItemCodes( [...result.products, ...result.configurations], products );
      this.props.getProducts( codes ).then( response => this.props.getPrices( response?.products.map( (product) => convertToLineItem(product, user) ) ) );

      // if the combinationId of a product is -1 then only it is individual product with out additional products
      result.products?.forEach( product => { 
        // if( product.combinationId === -1 ) {
          this.props.addToCartFromLocalStore( { 
          product: {...product, additionalProducts: [],
          deliveryOption:product.deliveryOption ||productList.filter(item=>item.product==product.name)?.firstOrDefault()?.deliveryOption,
          noteByUser:product.noteByUser!==null && typeof(product.noteByUser) !== "undefined"?product.noteByUser:''
          }, 
          amount: productList.find(item=>(item.product==product.code || item.product== product.name))?.quantity || 1, 
          options: {},
          deliveryOption:product.deliveryOption ||productList.filter(item=>item.product==product.name)?.deliveryOption,
          noteByUser:product.noteByUser!==null && typeof(product.noteByUser) !== "undefined"?product.noteByUser:'' } ); 
          productList.shift();
        //}
      });
      let readyAssembledproductlist = [];
      let readyAssembledlist = [];
      result.configurations?.forEach( configuration => { 
        const isReadyAssembled = ( user.country.indexOf('CBOL') > -1 || user.country.indexOf('Cbol') > -1 || 
            user.authenticationType == 'Apttus' || user.authenticationType == 'File' ) && 
            siteSettings.createSupercodeInSap && configuration;
        const accessories = getUserAssignments( configuration.configuration ).filter( a => !configuration.configuration.model.variables.any( i => i.name === a.key ) );
        if( isReadyAssembled && configuration.configuration && 
          configuration.configuration.productModelType === 1 && accessories.length > 0 ){
          readyAssembledproductlist = [...readyAssembledproductlist,...getConfiguration(configuration,user)];
          readyAssembledlist = [...readyAssembledlist, productList.find(item=>((item.product==configuration.code || item.product== configuration.name) && (item.superCodeLSO==configuration.superCodeLSO))&&(item.noteByUser==configuration.noteByUser))];
          productList.shift();
        }
        else{
          this.props.addToCartFromLocalStore( { 
            product: {...configuration, ...productList.filter(item=>((item.product==configuration.code || item.product== configuration.name) && (item.superCodeLSO==configuration.superCodeLSO))&&(item.noteByUser==configuration.noteByUser)).firstOrDefault(prod => prod?.importAccessories), 
            additionalProducts: [],looseadditionalProduct:configuration.looseAdditionalProduct,
            NST_description:productList.filter(item=>(item.product==configuration.name) && (item.superCodeLSO==configuration.superCodeLSO))?.firstOrDefault()?.NST_description,
            noteByUser: configuration.noteByUser!==null && typeof(configuration.noteByUser) !== "undefined"?configuration.noteByUser:'',
            deliveryOption:configuration.deliveryOption ||productList.filter(item=>((item.product==configuration.name) && (item.superCodeLSO==configuration.superCodeLSO))&&(item.noteByUser==configuration.noteByUser))?.firstOrDefault()?.deliveryOption,
          }, 
            deliveryOption:configuration.deliveryOption ||productList.filter(item=>((item.product==configuration.name) && (item.superCodeLSO==configuration.superCodeLSO))&&(item.noteByUser==configuration.noteByUser))?.firstOrDefault()?.deliveryOption,
            amount: productList.filter(item=>((item.product==configuration.code || item.product== configuration.name) && (item.superCodeLSO==configuration.superCodeLSO))&&(item.noteByUser==configuration.noteByUser)).firstOrDefault()?.quantity || 1,
            options: {},
            noteByUser: configuration.noteByUser!==null && typeof(configuration.noteByUser) !== "undefined"?configuration.noteByUser:'',
          } );
            productList.shift();
        }
      });
      if(readyAssembledproductlist?.length) {
        this.props.createSuperCode( readyAssembledproductlist )
        .then(superCodeResponses => {
            for(let superCodeResponse of superCodeResponses.data) {
              if( superCodeResponse.errors && superCodeResponse.errors.length ){
                this.addMessage( "Some error occured while creating supercode", "error", 0 );
              }
              else {
                let configuration = result.configurations.find(c => (superCodeResponse.variantId ===c.code || superCodeResponse.variantId ===c.name) && (superCodeResponse.superCodeLSO==c.superCodeLSO))
                configuration.superCode = superCodeResponse.superCode;
                this.props.addToCartFromLocalStore( { 
                  product: {...configuration, ...readyAssembledlist.filter(item=>((item.product==configuration.code || item.product== configuration.name) && (item.superCodeLSO==configuration.superCodeLSO))&&(item.noteByUser==configuration.noteByUser)).firstOrDefault(prod => prod?.importAccessories), additionalProducts: []},
                  amount: readyAssembledlist.filter(item=>((item.product==configuration.code || item.product== configuration.name) && (item.superCodeLSO==configuration.superCodeLSO))&&(item.noteByUser==configuration.noteByUser)).firstOrDefault()?.quantity || 1,
                  options: {},
                  noteByUser:configuration.noteByUser!==null && typeof(configuration.noteByUser) !== "undefined"?configuration.noteByUser:'' } );
                  readyAssembledlist.shift();
              }
            }
          })
      }
    }
  }

  componentDidMount() {
    const { cart } = this.props;
    if ( !Array.isArray( cart.stack ) || !cart.stack || !cart.stack.length ) {
      this.loadProductsFromLocalStore();
    }
  }

  getLastItem() {
    const { cart } = this.props;
    if ( cart && cart.stack && cart.stack.length === 0 ) return false ;
    return cart && cart.stack && cart.stack.length && Object.keys( cart ).filter( key => cart.lastUpdated ? key === cart.lastUpdated : key === cart.stack.peek() ).map( c => { return {...cart[c], product : {...cart[c].product, amount : cart[c].quantity }}}).firstOrDefault();
  }

  deleteFromCart = () => {
    const lastItem = this.getLastItem();
    this.props.deleteFromCart( lastItem );
    this.handleClose()
  }

  openRemovePopup = () => {
    const lastItem = this.getLastItem();

    // this.props.setPopup(
    //   {
    //     title: `Removing ${ lastItem.name }`,
    //     component: <PopupMessage
    //       text={ translate( 'Do you really want to remove {item} from the cart?', { item: lastItem.product.code } ) }
    //       actionText={ translate( 'Remove' ) }
    //       onClick={ this.deleteFromCart }
    //     />,
    //     showHeader: false,
    //     keepOpen: false
    //   }
    // );
    this.setState({show:true})
  }

  handleClose = ()=>{
    this.setState({show:false})
  }
  
  getCartPricingItems() {
    const { cart } = this.props;
    return Object.keys( cart ).filter( key => key !== 'stack' && key !== 'lastUpdated' ).map( v => { return { ...cart[v].product, amount : cart[v].quantity }} );
  }
  handleClick(VT,props){
   if(VT){
       if(click){ this.moveToCart(props)}  
   }
   if(this.props.flags.showSearchOverlay){
    this.props.hideSearchOverlay();
    }
  }
 
  moveToCart(props){  
    props.setPopup(
      {
        title: `Warning`,
        component: <PopupMessage
          text={ translate( 'Please be informed that material numbers are unique as per configurator items and their specifications. In the case the selected items are purchased, the material numbers might be subject to change.' ) }
          actionText={ translate( 'Ok' ) }
          cancelText={ translate( 'Dismiss' ) }
          onClick={()=>{props.history.push('/cart')}}
          popupType={ PopupType.Warning }
          
        />,
        showHeader: false,
        keepOpen: false
      }
    )    
      }
    changeView = ()=>{
      this.props.mobileView&&this.props.showCart()
    }
    getAccessoriesLength=(item)=>{
        const accessories=getAccessories(item)
        return accessories? accessories.length:0
      }
  render() {
    const { cart, siteSettings } = this.props;
    const lastItem = this.getLastItem();
    const cartQuantity = Object.values( cart ).reduce( ( total, item ) => total + ( item.quantity || 0 ), 0 );
    const {currentnode}=this.props
    const isVT1=currentnode?.customProperties?.isVT
    const { match, location, history } = this.props
    const cartClassName = classNames(!lastItem?"cart-button":"cart-button-hover")
    var index;
    if(isVT1){
             lastItem?.product?.properties?.map((prop,idx)=>{if(prop.name=="Translation.EN"){index= idx}})
            if(index){
              delete lastItem?.product?.properties[index];
            }
          } 
    return <><div className="cart-summary-menu"> 
    {isVT1?<>
      
      <Link className="cart-button" title={ translate( 'Cart' ) }  onClick={()=>{click=true,this.handleClick(isVT1,this.props)}} >
        <SvgImage source={ cartIcon } className="cart-icon" />
        <span>{ translate( 'Cart' ) }</span>
        { cartQuantity > 0 && <span className="amount">{ cartQuantity }</span> }
      </Link>

      { lastItem && <div className="cart-summary-menu-item">
        <LastAddedItem lastItem={ lastItem.product } deleteFromCart={ this.openRemovePopup } accessorylength= {this.getAccessoriesLength(lastItem.product)} />
        <div className="cart-summary-menu-footer">
          { PricingModule.showPrice( siteSettings.pricingModule ) &&
            <div className="cart-summary-menu-footer-price">
              <span title={ translate( 'Total' ) }>{`${translate("Total")}:`}</span> 
              <ProductPrice fromCartFooter lastAddedItem priceSize='big' products={ this.getCartPricingItems() } /> 
            </div> 
          }
          <Link className="goto-cart-button" title={ translate( 'Go to cart' ) } onClick={()=>{click=true,this.handleClick(isVT1,this.props)}}  >
            <SvgImage source={ cartIcon } className="cart-icon" />
            <span>{ translate( 'Go to cart' ) }</span>
          </Link>
        </div>
      </div> }</>:
      <>
      <Link className={cartClassName} title={ translate( 'Cart' ) }  to="/cart" onClick={()=>{
      this.props.mobileView&&this.props.setCartMobileView(true);
      if(this.props.flags.showSearchOverlay){
        this.props.hideSearchOverlay();
        }
      }}>
        {/* <SvgImage source={ cartIcon } className="cart-icon" /> */}
        <Badge sx={{display:{md:"flex",xs:!this.props.showConfigure.show?"flex":"none"}}} badgeContent={cartQuantity > 0 && <span className={cartQuantity<=99?"badge":"ellipsed-badge"}>{ cartQuantity }</span>}>
          <Box component="img" sx={{height: "24px",width: 
                      "24px"}} src={VectorCartLogoNew}></Box>
        </Badge>
        
        {/* <span>{ translate( 'Cart' ) }</span> */}
        {/* { cartQuantity > 0 && <span className="amount">{ cartQuantity }</span> } */}
      </Link>
      { lastItem && <div className="cart-summary-menu-item">
        <LastAddedItem lastItem={ lastItem.product } deleteFromCart={ this.openRemovePopup } accessorylength={this.getAccessoriesLength(lastItem.product)} />
        <div className="cart-summary-menu-footer">
          { PricingModule.showPrice( siteSettings.pricingModule ) &&
            <div className="cart-summary-menu-footer-price">
              {/* <span className='cart-price-heading' title={ translate( 'Total' ) }>{ translate( 'Total' ) }</span>  */}
              <span className='cart-price-heading' title={ translate( 'Total' ) }>{`${translate("Total")}:`}</span>
              <ProductPrice lastAddedItem priceSize='big' products={ this.getCartPricingItems() } /> 
            </div> 
          }
          <Link className="goto-cart-button" title={ translate( 'Go to cart' ) } to="/cart" onClick={ () => {
        if(this.props.flags.showSearchOverlay){
        this.props.hideSearchOverlay();
        }}
        } >
            {/* <SvgImage source={ cartIcon } className="cart-icon" /> */}
            <span className="goto-cart-button-font">{ translate( 'Go to cart' ) }</span>
          </Link>
        </div>
      </div> }
      </>}  
      
      </div>
      <Dialog open={this.state.show} onClose={this.handleClose} PaperProps={{sx:{position:"absolute", top:"160px"}}}>
      <RemoveProductsCart singleItemRemove text={ translate( 'Do you really want to remove {item} from the cart?', { item: lastItem?.product?.code } ) } 
                            onDelete={this.deleteFromCart}
                            onClose={this.handleClose}></RemoveProductsCart>
        </Dialog>
      </>;
  }
}

CartSummaryMenuComponent.propTypes = {
  cart: PropTypes.shape( {
    amount: PropTypes.string,
    items: PropTypes.array,
	stack: PropTypes.array
  } ),
  deleteFromCart: PropTypes.func.isRequired,
  setPopup: PropTypes.func.isRequired,
  getProducts: PropTypes.func.isRequired,
  siteSettings: PropTypes.shape( {
    pricingModule: PropTypes.number.isRequired
  } )
};

export const CartSummaryMenu = withRouter(connect(
  combineStates( cartState, productState, siteSettingsState, identityState, showConfigureState,flagState ),
  combineDispatchers( cartDispatcher, popupDispatcher, importDispatcher, productsDispatcher, priceDispatcher, mobilePageViewDispatcher, superCodeDispatcher,flagDispatcher )
)( CartSummaryMenuComponent ));